import moment from "moment";
export const priceFormat = (price) => {
  return Intl.NumberFormat().format(price);
};

export const numberFormat = (number) => {
  return Intl.NumberFormat().format(number);
};

export const timeFormat = ({ time, format = "LLLL" }) => {
  return moment(time).format(format);
};

export const fileSizeFormat = (size) => {
  if (size > 1024) {
    const kbSize = size / 1024;
    if (kbSize > 1024) {
      const mbSize = kbSize / 1024;
      return `${floatPrecision(mbSize, 2)} MB`;
    }
    return `${Math.round(kbSize)} kB`;
  }
  return `${size} B`;
};
